import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "../components/Logo";
import { EVENT_CONFIG } from "../config/event";
import { logAnalytics } from "../lib/api";

export default function ConfirmationPage() {
    useEffect(() => {
        document.title = "Iscrizione ricevuta | SafetyDesk81";
        logAnalytics("confirmation_view", {}, "/iscrizione-confermata");
    }, []);

    return (
        <div className="min-h-screen bg-[radial-gradient(600px_400px_at_50%_0%,#FBF3D4_0%,transparent_70%),#F4F6FB] flex flex-col">
            <header className="px-6 py-6">
                <Link to="/" data-testid="conf-home-link"><Logo size="md" /></Link>
            </header>
            <main className="flex-1 flex items-center justify-center px-5 py-10">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="bg-white rounded-3xl border border-navy-100 shadow-card p-8 md:p-14 max-w-2xl w-full text-center"
                    data-testid="confirmation-card"
                >
                    <motion.div
                        initial={{ scale: 0, rotate: -30 }}
                        animate={{ scale: 1, rotate: 0 }}
                        transition={{ delay: 0.25, type: "spring", stiffness: 220, damping: 15 }}
                        className="mx-auto w-24 h-24 rounded-full bg-mint flex items-center justify-center text-emerald-600 mb-8"
                    >
                        <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                    </motion.div>
                    <h1 className="font-display font-black text-navy-950 text-4xl md:text-5xl leading-tight">Iscrizione confermata!</h1>
                    <p className="mt-5 text-navy-700 text-lg leading-relaxed max-w-lg mx-auto">
                        Grazie per esserti iscritto alla presentazione ufficiale di <strong>SafetyDesk81</strong>.
                    </p>
                    <div className="mt-6 mx-auto max-w-md rounded-2xl bg-navy-50 border border-navy-100 p-5 text-left">
                        <div className="text-[10px] font-mono uppercase tracking-widest text-navy-400 mb-2">Dettagli evento</div>
                        <div className="text-navy-950 font-bold">{EVENT_CONFIG.EVENT_DAY_LABEL}</div>
                        <div className="text-navy-700 text-sm">{EVENT_CONFIG.EVENT_ADDRESS}</div>
                        <div className="mt-3 pt-3 border-t border-navy-100 text-sm text-navy-700 space-y-1">
                            <div><span className="font-mono font-bold text-navy-500 mr-2">{EVENT_CONFIG.EVENT_APERITIVO_TIME}</span> Aperitivo di benvenuto</div>
                            <div className="text-navy-950"><span className="font-mono font-bold text-gold-600 mr-2">{EVENT_CONFIG.EVENT_PRESENTATION_TIME}</span> <strong>Presentazione ufficiale</strong></div>
                            <div><span className="font-mono font-bold text-navy-500 mr-2">{EVENT_CONFIG.EVENT_DINNER_TIME}</span> Cena a buffet</div>
                        </div>
                    </div>
                    <p className="mt-4 text-navy-600 leading-relaxed max-w-lg mx-auto text-sm">
                        Riceverai a breve una email di conferma con tutti i dettagli. I posti sono limitati.
                    </p>

                    <Link
                        to="/"
                        data-testid="conf-back-home"
                        className="inline-flex items-center gap-2 mt-10 bg-navy-950 hover:bg-navy-900 text-white font-semibold px-7 py-3.5 rounded-full transition-all hover:-translate-y-0.5"
                    >
                        Torna alla pagina principale
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
                    </Link>

                    <div className="mt-10 pt-8 border-t border-navy-100 text-sm text-navy-600">
                        Per informazioni puoi contattare Centro Sicurezza Consulenze
                        <br />
                        <a href={`mailto:${EVENT_CONFIG.EVENT_CONTACT_EMAIL}`} className="text-navy-950 font-medium hover:text-gold-500 transition-colors">
                            {EVENT_CONFIG.EVENT_CONTACT_EMAIL}
                        </a>
                    </div>
                </motion.div>
            </main>
        </div>
    );
}
